import { FrameworkConfiguration, PLATFORM } from 'aurelia-framework';
import { RouteGenerator } from '@rightship-tech/common-ui/route-generator';

//Load styles
require("@rightship-tech/document-management-app/styles/core.scss");

export function configure(config: FrameworkConfiguration) {

    //Aurelia plugins
    // config.plugin(PLATFORM.moduleName('aurelia-validation')); 
    // config.plugin(PLATFORM.moduleName('aurelia-ui-virtualization')); 

    //Load global resources
    config.globalResources([

        //Components 
        PLATFORM.moduleName("./views/components/comp-document-requirement-card/comp-document-requirement-card"),
        
        //Partials
        PLATFORM.moduleName("./views/partials/documents-management/partial-documents-management"),
        PLATFORM.moduleName("./views/partials/documents-management-hybrid-inspections/partial-documents-management-hybrid-inspections"),
        PLATFORM.moduleName("./views/partials/document-requirements-widget/partial-document-requirements-widget"),
        PLATFORM.moduleName("./views/partials/document-requirements-overview-table/partial-document-requirements-overview-table"),
        PLATFORM.moduleName("./views/partials/bulk-upload-add-documents/partial-bulk-upload-add-documents"),
        PLATFORM.moduleName("./views/partials/bulk-upload-doc-config/partial-bulk-upload-doc-config"),
        PLATFORM.moduleName("./views/partials/bulk-upload-manage-access/partial-bulk-upload-manage-access")
    ]);

    //Load plugins
    config.plugin(PLATFORM.moduleName("@rightship-tech/common-ui"));
    
    //Generate routes
    const routeGenerator: RouteGenerator = config.container.get(RouteGenerator);
    const routes = [
        // { moduleId: "@rightship-tech/message-centre-app/views/pages/message-centre/message-centre", name: "Message Centre", route: "/message-centre" },
    ];

    //Set routes
    for (const route of routes) {
        routeGenerator.addRoute(route);
    }
}